﻿export class ItemImageModel {
  imageName: string;
  isGlobal: boolean;
}
